export default {
    cn: {
        monthlyIBResult: {
            indexText: '代理月结佣金结果',
            text: '代理月结佣金计算结果',
            datailText: '代理月结佣金计算结果明细',
            goback: '返回',
            start_time: "开始时间：",
            end_time: "结束时间：",
            selectTimeText: '选择日期',
            clauses_text: "显示条目数",
            amount: "总数",
            present: "当前",
            downloadExcelForms: "下载 Excel",
            downloadDetailExcel: "下载明细",
            nodata: "没有查询到数据",
            search: '搜索',
            commissionType: '佣金类别：',
            status: '状态：',
            confirm: '佣金确定',
            reject: '佣金拒绝',
            rejectMessage: '请输入拒绝原因',
            commit: '您真的要确定/拒绝吗?',
            spread: '展开',
            fold: '折叠',
            sheetName: ['额外返佣', '下层返佣'],
            downloadName: '代理月结佣金明细',
            proxyAccount: '代理账号：',
            selectKeys: { "id": "代理账号", "depositAccount": "入金账号" },
            typeList: { "-1": "所有", "0": "额外返佣", "1": "下层返佣" },
            IBStatusList: { "-1": "所有", "2": "未确定", "3": "已确定", "4": "已拒绝" },
            statusList: { "-1": "所有", "0": "未确定", "1": "全部确定", "2": "部分确定" },
            total: { total: "合计", part: "part", index: 1 },
            detailTotal: { total: '合计', lots: '总交易量', index: 2, part: 'part' },
            internal: { internal: '总额外返佣', index: 1, part: 'part' },
            afterrule: { afterrule: '总额外返佣(调整后)', index: 1, part: 'part' },
            monthlyTh: [
                { key: 'REPORT_ID', name: '编号' },
                { key: 'IBCommissionResult', name: '代理佣金结果', unneed: false },
                { key: 'DATE_FROM', name: '开始时间' },
                { key: 'DATE_TO', name: '结束时间' },
                { key: 'LAST_UPDATE', name: '完成时间', changeTime: true },
                { key: 'status', name: '状态' }
            ],
            commmissionTh: [
                { key: 'type', name: '佣金类别' },
                { key: 'IB_ID', name: '代理账号' },
                { key: 'NAME', name: '代理姓名' },
                { key: 'AMOUNT', name: '金额' },
                { key: 'status', name: '状态' },
                { key: 'REJECT_REASON', name: '拒绝原因' },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' },
                { key: 'DEPOSIT_COMMENT', name: '佣金注解' },
                { key: 'UPDATE_BY', name: '最后更新' },
                { key: 'LAST_UPDATE', name: '更新时间', changeTime: true }
            ],
            commmissionTh_v2: [
                { key: 'type', name: '佣金类别' },
                { key: 'IB_ID', name: '代理账号' },
                { key: 'NAME', name: '代理姓名' },
                { key: 'DEPOSIT_PLATFORM', name: '交易平台' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: '入金账号' },
                { key: 'AMOUNT', name: '金额' },
                { key: 'status', name: '状态' },
                { key: 'REJECT_REASON', name: '拒绝原因' },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金单号' },
                { key: 'DEPOSIT_COMMENT', name: '佣金注解' },
                { key: 'UPDATE_BY', name: '最后更新' },
                { key: 'LAST_UPDATE', name: '更新时间', changeTime: true }
            ],
            firstTh: {
                TYPE: '佣金类别',
                IB_ID: '代理账号',
                NAME: '代理姓名',
                AMOUNT: '金额(已调整)',
                TOTAL_COMMISSION: '总额外佣金'
            },
            firstTh_v2: {
                TYPE: '佣金类别',
                IB_ID: '代理账号',
                DEPOSIT_ACCOUNT: '入金账号',
                NAME: '代理姓名',
                AMOUNT: '金额(已调整)',
                PLATFORM: '交易平台',
                TOTAL_COMMISSION: '总额外佣金'
            },
            secondTh: {
                TYPE: '佣金类别',
                IB_ID: '代理账号',
                NAME: '代理姓名',
                AMOUNT: '金额',
                SUB_IB_ID: '下层代理账号',
                SUB_DEPOSIT_ACCOUNT: '下层代理入金账号',
                RULE_ID: '规则',
                VALUE: '规则参数',
                PRODUCT_GROUP: '产品',
                TOTAL_VOLUME: '总手数',
                INTERNAL_COMMISSION: '内佣金额',
                INTERNAL_COMMISSION_DIFF: '内佣金额(差值)',
                RULE_COMMISSION: '总金额'
            },
            lowerTh: [
                { key: 'ib_id', name: '下层代理账号' },
                { key: 'SUB_DEPOSIT_ACCOUNT', name: '下层代理入金账号' },
                { key: 'NAME', name: '代理姓名' },
                { key: 'rule_id', name: '规则' },
                { key: 'VALUE', name: '规则参数' },
                { key: 'product_group', name: '产品' },
                { key: 'TOTAL_VOLUME', name: '总手数' },
                { key: 'INTERNAL_COMMISSION', name: '内佣金额' },
                { key: 'INTERNAL_COMMISSION_DIFF', name: '内佣金额(差值)' },
                { key: 'RULE_COMMISSION', name: '总金额' },
            ]
        }
    },
    hk: {
        monthlyIBResult: {
            indexText: '代理月結佣金結果',
            text: '代理月結佣金計算結果',
            datailText: '代理月結佣金計算結果明細',
            goback: '返回',
            start_time: "開始時間：",
            end_time: "結束時間：",
            selectTimeText: '選擇日期',
            clauses_text: "顯示條目數",
            amount: "總數",
            present: "當前",
            downloadExcelForms: "下載 Excel",
            downloadDetailExcel: "下載明細",
            search: "搜索",
            nodata: "沒有查詢到數據",
            commissionType: '佣金類別：',
            status: '狀態：',
            confirm: '佣金確定',
            reject: '佣金拒絕',
            rejectMessage: '請輸入拒絕原因',
            commit: '您真的要確定/拒絕嗎?',
            spread: '展開',
            fold: '摺疊',
            sheetName: ['額外返佣', '下層返佣'],
            downloadName: '代理月結佣金明細',
            proxyAccount: '代理賬號：',
            selectKeys: { "0": "代理賬號", "1": "入金賬號" },
            typeList: { "-1": "所有", "0": "額外返佣", "1": "下層返佣" },
            IBStatusList: { "-1": "所有", "2": "未確定", "3": "已確定", "4": "已拒絕" },
            statusList: { "-1": "所有", "0": "未確定", "1": "全部確定", "2": "部分確定" },
            total: { total: "合計", part: "part", index: 1 },
            detailTotal: { total: '合計', lots: '總交易量', index: 2, part: 'part' },
            internal: { internal: '總額外返佣', index: 1, part: 'part' },
            afterrule: { afterrule: '總額外返佣(調整后)', index: 1, part: 'part' },
            monthlyTh: [
                { key: 'REPORT_ID', name: '編號' },
                { key: 'IBCommissionResult', name: '代理佣金結果', unneed: false },
                { key: 'DATE_FROM', name: '開始時間' },
                { key: 'DATE_TO', name: '結束時間' },
                { key: 'LAST_UPDATE', name: '完成時間', changeTime: true },
                { key: 'status', name: '狀態' }
            ],
            commmissionTh: [
                { key: 'type', name: '佣金類別' },
                { key: 'IB_ID', name: '代理賬號' },
                { key: 'NAME', name: '代理姓名' },
                { key: 'AMOUNT', name: '金額' },
                { key: 'status', name: '狀態' },
                { key: 'REJECT_REASON', name: '拒絕原因' },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' },
                { key: 'DEPOSIT_COMMENT', name: '佣金注解' },
                { key: 'UPDATE_BY', name: '最後更新' },
                { key: 'LAST_UPDATE', name: '更新時間', changeTime: true }
            ],
            commmissionTh_v2: [
                { key: 'type', name: '佣金類別' },
                { key: 'IB_ID', name: '代理賬號' },
                { key: 'NAME', name: '代理姓名' },
                { key: 'DEPOSIT_PLATFORM', name: '交易平台' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: '入金賬號' },
                { key: 'AMOUNT', name: '金額' },
                { key: 'status', name: '狀態' },
                { key: 'REJECT_REASON', name: '拒絕原因' },
                { key: 'DEPOSIT_ORDER_ID', name: '佣金單號' },
                { key: 'DEPOSIT_COMMENT', name: '佣金注解' },
                { key: 'UPDATE_BY', name: '最後更新' },
                { key: 'LAST_UPDATE', name: '更新時間', changeTime: true }
            ],
            firstTh: {
                TYPE: '佣金類別',
                IB_ID: '代理賬號',
                NAME: '代理姓名',
                AMOUNT: '金額(已調整)',
                TOTAL_COMMISSION: '總額外佣金'
            },
            firstTh_v2: {
                TYPE: '佣金類別',
                IB_ID: '代理賬號',
                DEPOSIT_ACCOUNT: '入金賬號',
                NAME: '代理姓名',
                AMOUNT: '金額(已調整)',
                PLATFORM: '交易平台',
                TOTAL_COMMISSION: '總額外佣金'
            },
            secondTh: {
                TYPE: '佣金類別',
                IB_ID: '代理賬號',
                NAME: '代理姓名',
                AMOUNT: '金額',
                SUB_IB_ID: '下層代理賬號',
                SUB_DEPOSIT_ACCOUNT: '下層代理入金賬號',
                RULE_ID: '規則',
                VALUE: '規則參數',
                PRODUCT_GROUP: '產品',
                TOTAL_VOLUME: '總手數',
                INTERNAL_COMMISSION: '內佣金額',
                INTERNAL_COMMISSION_DIFF: '內佣金額(差值)',
                RULE_COMMISSION: '總金額'
            },
            lowerTh: [
                { key: 'ib_id', name: '下層代理賬號' },
                { key: 'SUB_DEPOSIT_ACCOUNT', name: '下層代理入金賬號' },
                { key: 'NAME', name: '代理姓名' },
                { key: 'rule_id', name: '規則' },
                { key: 'VALUE', name: '規則參數' },
                { key: 'product_group', name: '產品' },
                { key: 'TOTAL_VOLUME', name: '總手數' },
                { key: 'INTERNAL_COMMISSION', name: '內佣金額' },
                { key: 'INTERNAL_COMMISSION_DIFF', name: '內佣金額(差值)' },
                { key: 'RULE_COMMISSION', name: '總金額' },
            ]
        }
    },
    en: {
        monthlyIBResult: {
            indexText: 'IB Monthly Commission Result',
            text: 'IB Monthly Commission Result',
            datailText: 'IB Monthly Commission Result Detail',
            goback: 'Go Back',
            start_time: "Start Time：",
            end_time: "End Time：",
            selectTimeText: 'Select Date',
            search: 'Search',
            clauses_text: "Display",
            amount: " Total Count",
            present: "Current",
            downloadExcelForms: "Download Excel",
            downloadDetailExcel: "Download Detail",
            nodata: "No data found",
            search: 'Search',
            commissionType: 'Type：',
            status: 'Status：',
            confirm: 'Confirm',
            reject: 'Reject',
            rejectMessage: 'Please enter a reject reason',
            commit: 'Do you really want to confirm/reject?',
            spread: 'Expand',
            fold: 'Collapse',
            sheetName: ['ExtraCommission', 'LowerLevelCommission'],
            downloadName: 'IBMonthlyCommissionDetail',
            proxyAccount: 'Account：',
            selectKeys: { "0": "IB Account", "1": "Deposit Account" },
            typeList: { "-1": "All", "0": "Extra Commission", "1": "Lower Level Commission" },
            IBStatusList: { "-1": "All", "2": "Unconfirmed", "3": "Confirmed", "4": "Rejected" },
            statusList: { "-1": "All", "0": "Unconfirmed", "1": "All confirmed", "2": "Partially confirmed" },
            total: { total: "Total", part: "part", index: 1 },
            detailTotal: {
                total: 'Total',
                lots: 'Total Volume',
                index: 2,
                part: 'part'
            },
            internal: { internal: 'Extra Commission Amount', index: 1, part: 'part' },
            afterrule: { afterrule: 'Extra Commission Amount(After Rule)', index: 1, part: 'part' },
            monthlyTh: [
                { key: 'REPORT_ID', name: 'Record ID' },
                { key: 'IBCommissionResult', name: 'IB Commmission Result', unneed: false },
                { key: 'DATE_FROM', name: 'Start Time' },
                { key: 'DATE_TO', name: 'End Time' },
                { key: 'LAST_UPDATE', name: 'Completion Time', changeTime: true },
                { key: 'status', name: 'Status' }
            ],
            commmissionTh: [
                { key: 'type', name: 'Commission Type' },
                { key: 'IB_ID', name: 'IB Account' },
                { key: 'NAME', name: 'IB Name' },
                { key: 'AMOUNT', name: 'Amount' },
                { key: 'status', name: 'Status' },
                { key: 'REJECT_REASON', name: 'Reject Reason' },
                { key: 'DEPOSIT_ORDER_ID', name: 'Order ID' },
                { key: 'DEPOSIT_COMMENT', name: 'Comment' },
                { key: 'UPDATE_BY', name: 'Update By' },
                { key: 'LAST_UPDATE', name: 'Last Update', changeTime: true }
            ],
            commmissionTh_v2: [
                { key: 'type', name: 'Commission Type' },
                { key: 'IB_ID', name: 'IB Account' },
                { key: 'NAME', name: 'IB Name' },
                { key: 'DEPOSIT_PLATFORM', name: 'Trade Platform' },
                { key: 'DEPOSIT_ACCOUNT_ID', name: 'Deposit Account' },
                { key: 'AMOUNT', name: 'Amount' },
                { key: 'status', name: 'Status' },
                { key: 'REJECT_REASON', name: 'Reject Reason' },
                { key: 'DEPOSIT_ORDER_ID', name: 'Order ID' },
                { key: 'DEPOSIT_COMMENT', name: 'Comment' },
                { key: 'UPDATE_BY', name: 'Update By' },
                { key: 'LAST_UPDATE', name: 'Last Update', changeTime: true }
            ],
            firstTh: {
                TYPE: 'Commission Type',
                IB_ID: 'IB Account',
                NAME: 'IB Name',
                AMOUNT: 'Amount(Adjusted)',
                TOTAL_COMMISSION: 'Total Extra Commission'
            },
            firstTh_v2: {
                TYPE: 'Commission Type',
                IB_ID: 'IB Account',
                DEPOSIT_ACCOUNT: 'Deposit Account',
                NAME: 'IB Name',
                AMOUNT: 'Amount(Adjusted)',
                PLATFORM: 'Trade Platform',
                TOTAL_COMMISSION: 'Total Extra Commission'
            },
            secondTh: {
                TYPE: 'Commission Type',
                IB_ID: 'IB Account',
                NAME: 'IB Name',
                AMOUNT: 'Amount',
                SUB_IB_ID: 'Sub IB Account',
                SUB_DEPOSIT_ACCOUNT: 'Sub IB Deposit Account',
                RULE_ID: 'Rule',
                VALUE: 'Rule Parameter',
                PRODUCT_GROUP: 'Product Group',
                TOTAL_VOLUME: 'Total Volume',
                INTERNAL_COMMISSION: 'Internal Commission',
                INTERNAL_COMMISSION_DIFF: 'Internal Commission(Diff)',
                RULE_COMMISSION: 'Rule Commission'
            },
            lowerTh: [
                { key: 'ib_id', name: 'IB Account' },
                { key: 'SUB_DEPOSIT_ACCOUNT', name: 'Sub IB Deposit Account' },
                { key: 'NAME', name: 'IB Name' },
                { key: 'rule_id', name: 'Rule' },
                { key: 'VALUE', name: 'Rule Parameter' },
                { key: 'product_group', name: 'Product Group' },
                { key: 'TOTAL_VOLUME', name: 'Total Volume' },
                { key: 'INTERNAL_COMMISSION', name: 'Internal Commission' },
                { key: 'INTERNAL_COMMISSION_DIFF', name: 'Internal Commission(Diff)' },
                { key: 'RULE_COMMISSION', name: 'Rule Commission' },
            ]
        }
    }
}



// WEBPACK FOOTER //
// ./src/MultiLanguage/CommissionSetting/IB/monthlyIBResult.js